var map = {
	"./faq-de.json": "6b88",
	"./faq-en.json": "42cd",
	"./faq-es.json": "4a31",
	"./faq-fr.json": "b53a",
	"./faq-hu.json": "e23d",
	"./faq-lt.json": "461d",
	"./faq-nl.json": "9ad0",
	"./faq-se.json": "c168"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "042d";